<template>
  <div class="wrapper">
    <h2>{{ universityName }}</h2>
    <h2>统计报告</h2>
    <div class="departsituation" style="border-top: 1px solid #dbdbdb;">
      <!-- @click="editdepartdata('depart')" -->
      <div class="chatbox departchatBox">
        <h2 style="font-size:19px;margin-bottom:0;">部门合格统计</h2>
        <div ref="departrate" class="departchat" :style="{width: departLength* 80+100 + 'px'}"></div>
      </div>
      <!-- @click="editdepartdata('sexechart')" -->
      <div class="chatbox sexechart" ref="sexechart"></div>
    </div>
    <div class="departsituation">
      <!-- @click="editdepartdata('theory')" -->

      <div
        class="chatbox theoryechart"
        id="theoryechart"
        ref="theoryechart"
      ></div>
      <!-- 灭火统计 -->
      <div class="chatbox outfireechart" ref="operechart"></div>
      <!-- @click="editdepartdata('outfire')" -->
      <div class="chatbox outfireechart" ref="outfireechart" v-if="isShowOutfire"></div>
    </div>
    <!-- @click="editdepartdata('timechat')" -->
    <div class="departsituation" v-if="isShowOutfiretime">
      <div class="chatbox outfiretimechat" ref="outfiretimechat"></div>
    </div>
    <depart
      v-for="item in departmentlist"
      :key="item.departmentId"
      :universityId="universityId"
      :departmentdata="item"
      :activecode="activecode"
    ></depart>
  </div>
</template>

<script>
import depart from "./components/departmentdata";
import Axios from "@/Axios";
import HighCharts from "highcharts";

export default {
  name: "Chartpage",
  components: {
    depart,
  },
  props: {},
  data() {
    return {
      isShowOutfire: false,
      isShowOutfiretime: true,
      departeditshow: false, //部门合格率图表数据修改弹出框
      departdata: [], //部门合格率图表数据
      departLength: 3,
      sexdata: [], //性别合格率图表数据
      highchartdata: [], //理论合格率图表数据
      outfiredata: [], //灭火动作合格率图表数据
      timechatdata: [], //灭火时间合格率图表数据
      editor: null,
      editmodo: "",
      description: "成绩表管理页面",
      // 表头
      columns: [
        {
          title: "姓名",
          align: "center",
          dataIndex: "name",
        },
        {
          title: "编码",
          align: "center",
          dataIndex: "digital_id",
        },
        {
          title: "部门",
          align: "center",
          dataIndex: "department_text",
        },
        {
          title: "性别",
          align: "center",
          dataIndex: "sex",
        },
        {
          title: "年龄",
          align: "center",
          dataIndex: "age",
        },
        {
          title: "理论分数",
          align: "center",
          dataIndex: "theory_score",
        },
        {
          title: "实践得分",
          align: "center",
          dataIndex: "practice_score",
        },

        {
          title: "灭火秒数",
          align: "center",
          dataIndex: "outfire_time",
          scopedSlots: { customRender: "outfiretime" },
        },
        //
        {
          title: "操作",
          dataIndex: "action",
          align: "center",
          fixed: "right",
          width: 147,
          scopedSlots: { customRender: "action" },
        },
      ],
      tableloading: false,
      //   url: {
      //     list: '/qrcode/yhaDigitalCode/selectNoDataStudent',
      //     // getlist: '/qrcode/yhaDigitalCode/selectNoDataStudent',
      //     delete: '/yha_score/yhaScore/delete',
      //     deleteBatch: '/yha_score/yhaScore/deleteBatch',
      //     exportXlsUrl: '/yha_score/yhaScore/exportXls',
      //     importExcelUrl: 'yha_score/yhaScore/importExcel',
      //   },
      dictOptions: {},
      universityId: "",
      universityName: "",
      // activecode
      universitylist: [],
      activecode: undefined,
      showchat: false,
      activecodelist: [],
      departmentlist: [],
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      chartOptions: {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 75,
            beta: 0,
          },
        },
        title: {
          text: "理论考试",
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 45,
            dataLabels: {
              enabled: true,
              format: "{point.name}",
            },
          },
        },
        series: [
          {
            type: "pie",
            name: "浏览器占比",
            data: [
              ["Firefox", 45.0],
              ["IE", 26.8],
              {
                name: "Chrome",
                y: 12.8,
                sliced: true,
                selected: true,
              },
              ["Safari", 500],
              ["Opera", 6.2],
              ["Others", 0.7],
            ],
          },
        ],
      },
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.activecode = this.$route.query.activeCode;
    this.universityId = this.$route.query.universityId;
    this.universityName = this.$route.query.universityId_dictText;
    this.getbardata();
    this.getoutfiretimedata();
  },
  methods: {
    // 获取报告数据
    getbardata() {
      var that = this;
      var xdata = [];
      var ydata = [];
      var tabledata = [];
      this.departmentlist = [];
      console.log("456", this.$route.query);

      if (!this.$route.query.activeCode || !this.$route.query.universityId) {
        return;
      }
      console.log("456");
      //   that.showchat = true;
      Axios.get("/repcomposer/repComposer/report", {
        params: {
          activeCode: this.$route.query.activeCode,
          departmentId: 0,
          universityId: this.$route.query.universityId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          var records = res.data.result.records;
          this.reportdata = res.data.result.records;
          if (!records.length) {
            that.$message.info("此次活动暂时没有成绩信息");
            that.showchat = false;
            return;
          }
          var newlist = records.map((item, index) => {
            var data = item.visualData || item.originalData;
            data = JSON.parse(data);
            // 整体统计
            // if (item.step == "1") {
            //   this.wholedatahandle(data);
            // }
            // 部门统计
            if (item.step == "2") {
              var departdata = that.departdatahandle(data);
              console.log("departdata", departdata);
              that.departdrawbar(
                that.$refs.departrate,
                departdata[0],
                departdata[1],
                "",
                ""
              );
              // that.data = that.tabledatahandle(data);
            }
            // 理论统计
            if (item.step == "3") {
                that.drawbin(
                  that.$refs.theoryechart,
                  that.bindatahandle(data),
                  "理论统计"
                );
            }
            // sexechart theoryechart operechart  outfireechart
            //性别合格率统计
            if (item.step == "4") {
              that.sexdata = that.formatsexdata(data);
              that.drawbin(
                that.$refs.sexechart,
                that.binsexdatahandle(that.formatsexdata(data)),
                "性别合格率统计"
              );
            }
            // 灭火统计
            if (item.step == 5) {
              that.draw(
                that.$refs.operechart,
                "灭火统计",
                that.bindatahandle(data)
              );
            }
            //灭火动作统计
            if (item.step == "6") {
              if (data.length !== 0) {
                this.isShowOutfire = true
              }
              data = that.formatdata(data);
              that.drawbar(
                that.$refs.outfireechart,
                that.baroutfiredatahandle(data)[0],
                that.baroutfiredatahandle(data)[1],
                "灭火动作统计",
                "动作"
              );
            }
          });
        }
      });
    },
    // 其他饼图数据处理
    bindatahandle(data) {
      if (data[0].rateMap) {
        delete data[0].rateMap
      }
      var arr = [];
      for (var key in data[0]) {
        var obj = {};
        obj.value = data[0][key];
        obj.name = key;
        arr.push(obj);
      }
      return arr;
    },
    // 获取灭火时间统计数据
    getoutfiretimedata() {
      if (!this.activecode || !this.universityId) {
        console.log(";;;;;;;;;;this.activecode", this.activecode);
        return;
      }
      let that = this;
      Axios.get("/repcomposer/repComposer/selectOutFireTimeData", {
        params: {
          activeCode: this.activecode,
          departmentId: 0,
          universityId: this.universityId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          console.log("res.data.result", res.data.result);
          if (res.data.result) {
            console.log("res.data.result---", res.data.result);
            if (res.data.result.length == 0) {
                this.isShowOutfiretime = false
                return
              }
            that.drawOutFireTimebin(
              that.$refs.outfiretimechat,
              that.handletimedata(that.formattimeareadata(res.data.result)),
              "灭火情况分析"
            );
          }
        }else {
          this.isShowOutfiretime = false
        }
      });
    },
    // 部门柱状图
    departdrawbar(dom, xdata, ydata, title, xName) {
      let that = this;
      // console.log(xdata, ydata, title);
      var mychart = this.$echarts.init(dom);
      mychart.setOption({
        title: {
          text: title,
          left: "23%",
          textAlign: "center",
        },
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: "{b}<br/>{a}:{c}%",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        yAxis: [
          {
            type: "value",
            name: "合格率%",
            axisLabel: {
              interval: 0,
              // rotate: 50,
            },
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        xAxis: [
          {
            type: "category",
            name: xName,
            nameGap: 0,
            data: xdata,
            // nameLocation: "center",
            // nameTextStyle. fontWeight
            axisLabel: {
              interval: 0,
              rotate: 50,
            },
          },
        ],
        series: [
          {
            type: "bar",
            name: xName,
            // formatter: "{a}：{c}",
            barWidth: "30%",
            data: ydata,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  // rotate:90,
                  // align:'left',
                  // verticalAlign:'middle',
                  // position: "insideBottom",
                  formatter: "{c}%",
                  position: "top",
                  textStyle: {
                    color: "black",
                    fontWeight: "blod",
                    fontSize: "20px",
                  },
                },
              },
            },
          },
        ],
      });
    },
    // 3D饼图
    highchartsBin(data) {
      // this.highchartdata = data
      HighCharts.chart("theoryechart", {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 75,
            beta: 0,
          },
        },
        title: {
          text: "理论考试",
          style: {
            fontWeight: "bold",
          },
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 45,
            dataLabels: {
              enabled: true,
              // format: '{point.name} 占比 {point.percentage}%， 人数: {point.y}',
              formatter: function () {
                //this 为当前的点（扇区）对象，可以通过  console.log(this) 来查看详细信息
                console.log("22565545+++++", this);
                return (
                  '<span style="color: ' +
                  this.point.color +
                  '">' +
                  this.key +
                  "<br>占比" +
                  this.percentage.toFixed(2) +
                  "%<br>" +
                  "人数" +
                  this.y +
                  "</span>"
                );
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            type: "pie",
            name: "占比",
            data: data,
          },
        ],
      });
    },
    // 柱状图
    drawbar(dom, xdata, ydata, title, xName) {
      // console.log(xdata, ydata, title);
      var mychart = this.$echarts.init(dom);
      mychart.clear();
      mychart.setOption({
        title: {
          text: title,
          left: "50%",
          textAlign: "center",
        },
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: "{b}<br/>{a}:{c}%",
        },
        grid: {
          left: "8%",
          right: "8%",
          bottom: "3%",
          containLabel: true,
        },
        yAxis: [
          {
            type: "value",
            name: "合格率%",
            // yAxis.nameTextStyle. verticalAlign
          },
        ],
        xAxis: [
          {
            type: "category",
            name: xName,
            // nameLocation:'start',
            data: xdata,
            axisLabel: {
              interval: 0,
              rotate: 50,
            },
            // nameRotate:"90",
            // axisLabel:{
            // formatter:function(value){
            //       return value.split("").join("\n");
            // }
            // },
            nameGap: 0,
            axisTick: {
              alignWithLabel: true,
            },
            // nameLocation: "center",
            // nameTextStyle. fontWeight
          },
        ],
        series: [
          {
            name: "合格率",
            type: "bar",
            // formatter: "{a}：{c}",
            barWidth: "30%",
            data: ydata,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  // rotate:90,
                  // align:'left',
                  // verticalAlign:'middle',
                  // position: "insideBottom",
                  formatter: "{c}%",
                  position: "top",
                  textStyle: {
                    color: "red ",
                    fontWeight: "blod",
                    fontSize: "20px",
                  },
                },
              },
            },
          },
        ],
      });
    },
     // 灭火情况分析饼图
    drawOutFireTimebin(dom, data, bintitle) {
      var mychart = this.$echarts.init(dom);
      mychart.clear();
      console.log("饼图", data);
      mychart.setOption({
        baseOption: {
          color:['red','blue','green','gray','#C0C0C0','#da70d6','#32cd32','#6495ed',
            '#ff69b4','#ba55d3','#cd5c5c','#ffa500','#40e0d0',
            '#1e90ff','#ff6347','#7b68ee','#00fa9a','#ffd700',
            '#6699FF','#ff6666','#3cb371','#b8860b','#30e0e0'],
          title: {
            text: bintitle,
            left: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c} ({d}%)",
          },
          legend: {
            // orient: 'vertical',
            // top: 'middle',
            bottom: 10,
            left: "center",
            selectedMode: false, //取消图例上的点击事件
          },
          series: [
            {
              type: "pie",
              radius: "65%",
              center: ["50%", "50%"],
              selectedMode: "single",
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: "{b} : {c} ({d}%)",
                  },
                  lableLine: { show: true },
                },
              },
            },
          ],
        },
        media: [
          {
            query:{
              maxWidth: 500
            },
            option: {
              color:['gray','green','blue','red','#87cefa','#da70d6','#32cd32','#6495ed',
            '#ff69b4','#ba55d3','#cd5c5c','#ffa500','#40e0d0',
            '#1e90ff','#ff6347','#7b68ee','#00fa9a','#ffd700',
            '#6699FF','#ff6666','#3cb371','#b8860b','#30e0e0'],
              title: {
            text: bintitle,
            left: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c} ({d}%)",
          },
          legend: {
            // orient: 'vertical',
            // top: 'middle',
            bottom: 10,
            left: "center",
            selectedMode: false, //取消图例上的点击事件
          },
          color: [
            'red', 'blue','green','gray',
            "#7ce5bc",
            "#fc5531",
            "#dee1e6",
            "#495DBC",
            "#b43050",
            "#fefece",
            "#4d7493",
          ],
          series: [
            {
              type: "pie",
              radius: "25%",
              center: ["50%", "50%"],
              selectedMode: "single",
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: "{b} : {c} ({d}%)",
                  },
                  lableLine: { show: true },
                },
              },
            },
          ],
            }
          }
        ]
      });
    },
    // 饼图
    drawbin(dom, data, bintitle) {
      var mychart = this.$echarts.init(dom);
      mychart.clear();
      console.log("饼图", data);
      mychart.setOption({
        baseOption: {
          color:['gray','green','blue','red','#87cefa','#da70d6','#32cd32','#6495ed',
            '#ff69b4','#ba55d3','#cd5c5c','#ffa500','#40e0d0',
            '#1e90ff','#ff6347','#7b68ee','#00fa9a','#ffd700',
            '#6699FF','#ff6666','#3cb371','#b8860b','#30e0e0'],
          title: {
            text: bintitle,
            left: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c} ({d}%)",
          },
          legend: {
            // orient: 'vertical',
            // top: 'middle',
            bottom: 10,
            left: "center",
            selectedMode: false, //取消图例上的点击事件
          },
          series: [
            {
              type: "pie",
              radius: "65%",
              center: ["50%", "50%"],
              selectedMode: "single",
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: "{b} : {c} ({d}%)",
                  },
                  lableLine: { show: true },
                },
              },
            },
          ],
        },
        media: [
          {
            query:{
              maxWidth: 500
            },
            option: {
              color:['gray','green','blue','red','#87cefa','#da70d6','#32cd32','#6495ed',
            '#ff69b4','#ba55d3','#cd5c5c','#ffa500','#40e0d0',
            '#1e90ff','#ff6347','#7b68ee','#00fa9a','#ffd700',
            '#6699FF','#ff6666','#3cb371','#b8860b','#30e0e0'],
              title: {
            text: bintitle,
            left: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c} ({d}%)",
          },
          legend: {
            // orient: 'vertical',
            // top: 'middle',
            bottom: 10,
            left: "center",
            selectedMode: false, //取消图例上的点击事件
          },
          color: [
            'red', 'blue','green','gray',
            "#7ce5bc",
            "#fc5531",
            "#dee1e6",
            "#495DBC",
            "#b43050",
            "#fefece",
            "#4d7493",
          ],
          series: [
            {
              type: "pie",
              radius: "25%",
              center: ["50%", "50%"],
              selectedMode: "single",
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: "{b} : {c} ({d}%)",
                  },
                  lableLine: { show: true },
                },
              },
            },
          ],
            }
          }
        ]
      });
    },
    // 灭火统计饼图
    draw(dom, bintitle, data) {
      // console.log(dom);
      var mychart = this.$echarts.init(dom);
      mychart.setOption({
        baseOption: {
          color:['gray','green','blue','red','#87cefa','#da70d6','#32cd32','#6495ed',
            '#ff69b4','#ba55d3','#cd5c5c','#ffa500','#40e0d0',
            '#1e90ff','#ff6347','#7b68ee','#00fa9a','#ffd700',
            '#6699FF','#ff6666','#3cb371','#b8860b','#30e0e0'],
          title: {
            text: bintitle,
            left: "center",
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c} ({d}%)",
          },
          legend: {
            // orient: 'vertical',
            // top: 'middle',
            bottom: 10,
            left: "center",
            selectedMode: false, //取消图例上的点击事件
          },
          series: [
            {
              type: "pie",
              radius: "65%",
              center: ["50%", "50%"],
              selectedMode: "single",
              data: data,

              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    formatter: "{b} : {c} ({d}%)",
                  },
                  lableLine: { show: true },
                },
              },
            },
          ],
        },
        media: [
          {
            query: {
              maxWidth: 500,
            },
            option: {
              color:['gray','green','blue','red','#87cefa','#da70d6','#32cd32','#6495ed',
            '#ff69b4','#ba55d3','#cd5c5c','#ffa500','#40e0d0',
            '#1e90ff','#ff6347','#7b68ee','#00fa9a','#ffd700',
            '#6699FF','#ff6666','#3cb371','#b8860b','#30e0e0'],
              title: {
                text: bintitle,
                left: "center",
              },
              tooltip: {
                trigger: "item",
                formatter: "{b} : {c} ({d}%)",
              },
              legend: {
                // orient: 'vertical',
                // top: 'middle',
                bottom: 10,
                left: "center",
                selectedMode: false, //取消图例上的点击事件
              },
              series: [
                {
                  type: "pie",
                  radius: "25%",
                  center: ["50%", "50%"],
                  selectedMode: "single",
                  data: data,

                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                  itemStyle: {
                    normal: {
                      label: {
                        show: true,
                        formatter: "{b} : {c} ({d}%)",
                      },
                      lableLine: { show: true },
                    },
                  },
                },
              ],
            },
          },
        ],
      });
    },
    // 部门统计数据处理
    departdatahandle(data) {
      console.log("部门统计数据处理", data);
      // this.departdata = data;
      this.departLength = data.length;
      // let
      var departdata = [];
      var xdata = [];
      var ydata = [];
      data.map((item) => {
        var obj = {};
        var passnum; //合格人数
        var nopassnum; //未合格人数
        var passrate; //合格率
        obj.nopass = item.不合格;
        obj.pass = item.合格;
        obj.passrate = ((item.合格 / (item.不合格 + item.合格)) * 100).toFixed(
          1
        );
        obj.departmentName = item.部门;
        obj.departmentId = item.departmentId;
        departdata.push(obj);

        // this.getbindata(item.departmentId);
      });
      departdata.sort(this.sortpassrate);
      this.departmentlist = departdata;
      departdata.map((item) => {
        xdata.push(item.departmentName);
        ydata.push(item.passrate);
      });

      return [xdata, ydata];
    },
    // 3D理论数据处理
    theorydata3D(data) {
      this.highchartdata = data;
      var arr = [];
      data.map((item) => {
        var obj = {
          y: item.人数,
          name: item.评价,
        };
        arr.push(obj);
      });
      this.highchartsBin(arr);
    },
    // 性别饼图数据处理
    binsexdatahandle(data) {
      var arr = [];
      data.map((item) => {
        var obj = {};
        obj.value = item.合格人数;
        obj.name = item.性别;
        arr.push(obj);
      });
      return arr;
    },
    // 灭火动作柱状图数据处理
    baroutfiredatahandle(data) {
      this.outfiredata = data;
      var xdata = [];
      var ydata = [];
      data.map((item) => {
        xdata.push(item.项目名称);
        var per = (
          (item.正确人数 / (item.正确人数 + item.错误人数)) *
          100
        ).toFixed(1);
        ydata.push(per);
      });
      return [xdata, ydata];
    },
    // 时间统计数据处理
    handletimedata(data) {
      this.timechatdata = data;
      var arr = [];
      data.map((item) => {
        var obj = {
          value: item.人数,
          name: item.时间范围,
        };
        arr.push(obj);
      });
      return arr;
    },
    // 理论数据格式转换
    formattheorydata(data) {
      console.log("44445", data[0]);
      var arr = [];
      for (var key in data[0]) {
        var obj = {
          人数: data[0][key],
          评价: key,
        };
        arr.push(obj);
      }
      return arr;
    },
    // 性别数据格式转换
    formatsexdata(data) {
      console.log("+-85645", data);
      var arr = [];
      data.map((item) => {
        var obj = {
          合格人数: item.合格,
          性别: item.性别,
        };
        arr.push(obj);
      });
      return arr;
    },
    // 灭火动作数据格式转换
    formatdata(data) {
      var arr = [];
      data.map((item) => {
        var obj = {
          正确人数: item.ACount,
          错误人数: item.BCount,
          项目名称: item._id,
        };
        arr.push(obj);
      });
      return arr;
    },
    // 时间数据格式转换
    formattimeareadata(data) {
      // console.log('.............', data)
      // return
      var arr = [];
      for (var key in data) {
        var obj = {
          人数: data[key],
          时间范围: key + "秒",
        };
        arr.push(obj);
      }
      return arr;
    },
    // 比较合格率
    sortpassrate(item1, item2) {
      return item2.passrate - item1.passrate;
    },
  },
  created() {},
};
</script>
<style scoped>
.wrapper{
  padding-top: 1em;
}
.chatbox {
  height: 300px;
}
@media screen and (min-width: 768px) {
  .departsituation {
    display: flex;
    margin-bottom: 30px;
    justify-content: space-around;
    align-items: center;
    height: 500px;
  }
}
@media screen and (min-width: 768px) {
  .departchatBox {
    height: 520px;
    width: 62%;
    box-sizing: border-box;
    padding: 2%;
    margin-left: 10px;
  }
}
@media screen and (min-width: 768px) {
  .departchat {
    width: 100%;
    height: 100%;
  }
}
@media screen and (max-width: 768px) {
  .departchatBox {
    height: 520px;
    width: 98%;
    margin: 0 auto;
    border-bottom: 1px solid #dbdbdb;
    box-sizing: border-box;
    padding: 2%;
    overflow-x: auto;
    overflow-y: hidden;
  }
}
@media screen and (max-width: 768px) {
  .departchat {
    height: 500px;
    /* width: 800px; */
    width: 90%;
  }
}
@media screen and (min-width: 768px) {
  .sexechart {
    height: 300px;
    width: 38%;
  }
}
@media screen and (max-width: 768px) {
  .sexechart {
    height: 300px;
    width: 90%;
    margin: 20px auto;
    border-bottom: 1px solid #dbdbdb;
  }
}
@media screen and (min-width: 768px) {
.outfireechart {
  width: 50%;
  height: 500px;
}
}
@media screen and (max-width: 768px) {
.outfireechart {
  width: 90%;
  height: 300px;
  margin: 0 auto;
  border-bottom: 1px solid #dbdbdb;
}
}
@media screen and (min-width: 768px) {
.theoryechart {
  width: 50%;
  height: 500px;
}
}
@media screen and (max-width: 768px) {
.theoryechart {
  width: 90%;
  height: 300px;
  margin: 21px auto;
  border-bottom: 1px solid #dbdbdb;
}
}
@media screen and (min-width: 768px) {
.outfiretimechat {
  width: 100%;
  height: 500px;
}
}
@media screen and (max-width: 768px) {
.outfiretimechat {
  width: 90%;
  height: 300px;
  margin: 20px auto;
  border-bottom: 1px solid #dbdbdb;
}
}
.itemdata {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.itemdepartname {
  width: 200px;
  text-align: right;
}
.itemvalue {
  width: 200px;
}
.valuetext {
  width: 100px;
  text-align: right;
}
h2 {
  /* height: 80px; */
  /* line-height: 80px; */
  color: #222222;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/views/chartpage/chartpage.vue